import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import YesNoQuestion
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackQuestion/YesNoQuestion';

const useStyles = buildUseStyles('UserFeedbackQuestion', (() => ({
  root: { },
})));

const UserFeedbackQuestion = ({ className, ...rest }) => {
  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Text
        text={'Was this helpful?'}
        variant={'body'}
        color={'mediumGray'}
      />
      <YesNoQuestion {...rest} />
    </Box>
  );
};

UserFeedbackQuestion.defaultProps = {
  className: '',
};

UserFeedbackQuestion.propTypes = {
  className: PropTypes.string,
};

export default UserFeedbackQuestion;
